import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    title: 'Auditoría de Energía',
    desc: 'Identificas qué está drenando tu conexión hoy mismo.'
  }, {
    num: '02',
    title: 'Inyección de Micro-Momentos',
    desc: 'Aplicas los rituales de 180 segundos en las grietas de tu rutina diaria.'
  }, {
    num: '03',
    title: 'Blindaje de Identidad',
    desc: 'Separas la logística de los hijos de tu espacio sagrado de pareja.'
  }];
  return <section className="px-6 py-10 max-w-4xl mx-auto" data-id="element-100">
      <motion.h3 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="font-serif text-4xl md:text-5xl text-center text-brand-light mb-10" data-id="element-101">
        Cómo <span className="text-brand-accent italic" data-id="element-102">funciona</span>
      </motion.h3>

      <div className="space-y-6" data-id="element-103">
        {steps.map((step, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} className="flex flex-col md:flex-row gap-6 items-start md:items-center relative" data-id="element-104">
            <div className="text-6xl md:text-7xl font-serif text-brand-accent/20 font-bold" data-id="element-105">
              {step.num}
            </div>
            <div className="md:ml-8" data-id="element-106">
              <h4 className="text-2xl font-medium text-brand-light mb-2" data-id="element-107">
                {step.title}
              </h4>
              <p className="text-brand-light/70 text-lg font-light" data-id="element-108">
                {step.desc}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}